import { IFirestoreListenerData, IFirestorePlugin, IFirestoreQueryData, IFirestoreRealtimeData } from './types';

export abstract class BaseFirestorePlugin implements IFirestorePlugin {
  id: string;
  name: string;
  enabled: boolean = true;

  constructor(id: string, name: string, enabled: boolean = true) {
    this.id = id;
    this.name = name;
    this.enabled = enabled;

    console.log(`${this.name} plugin initialized`);
  }

  disable() {
    this.enabled = false;
    console.log(`${this.name} plugin disabled`);
  }

  enable() {
    this.enabled = true;
    console.log(`${this.name} plugin enabled`);
  }

  beforeQuery?(queryData: Omit<IFirestoreQueryData, 'duration' | 'resultCount' | 'error'>): void {}
  afterQuery(queryData: IFirestoreQueryData): void {}
  afterListenerAdded(listenerData: IFirestoreListenerData): void {}
  afterListenerRemoved(listenerData: IFirestoreListenerData): void {}
  afterRealtimeDataReceived(realtimeData: IFirestoreRealtimeData): void {}
}
